// extracted by mini-css-extract-plugin
export default {"FeedItem":"feedItem_FeedItem__RP3C6","FeedItem_active":"feedItem_FeedItem_active__8PRO2"};